import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CarrierTickerComponent } from './carrier-ticker.component';

@NgModule({
  declarations: [CarrierTickerComponent],
  imports: [CommonModule],
  exports: [CarrierTickerComponent],
})
export class CarrierTickerModule {}